import React from 'react';
import { PermissionWrapper } from '../../../components/accessControl/PermissionWrapper';
import { ePermissions } from '../../../types/administration/userAdministration/ePermissions';
import { EditTagPage } from './EditTagPage';
import { useListTagsQuery } from '../../../API/tags/TagApi';
import { useParams } from 'react-router-dom';
import { ErrorMessageTW } from '../../../tailwindComponents/errorMessage/ErrorMessageTW';

export const EditTagContainer: React.FC = () => {
  const { tagId } = useParams<{ tagId: string }>();

  const { data: allTags = [], error: tagsFetchError } = useListTagsQuery();

  return (
    <PermissionWrapper allowedPermissions={[ePermissions.TagEdit]}>
      <ErrorMessageTW rtkError={tagsFetchError} />
      <EditTagPage tagId={tagId} tags={allTags} />
    </PermissionWrapper>
  );
};
